<template>
  <div id="app" class="col-md-5 col-xs-12 col-sm-12 col-12">
    <h1 class="big-title login-title">{{ $t('personalInformation') }}</h1>
    <form @submit="checkForm">
      <a-input
        :label="$t('labels.email')"
        type="email"
        placeholder="e: juanperez@mail.com"
        name="email"
        :error="form.email.error.length > 0"
        :errorMessage="form.email.error"
        v-model="form.email.value"
        @keyup="evaluateInput"
      />
      <a-input
        name="password"
        :label="$t('password')"
        :type="showPassword ? 'text' : 'password'"
        v-model="form.password.value"
        :append-text="showPassword ? $t('m10') : $t('m11')"
        @click-append="showPassword = !showPassword"
        @keyup="evaluateInput"
        :error="form.password.error.length > 0"
        :errorMessage="form.password.error"
      />
      <div class="forget-your-password-container">
        <a
          @click="goToForgetPassword"
          href="/admin/sign-up/forget-password"
          class="forget-your-password"
          >{{ $t('m4') }}</a
        >
      </div>

      <a-btn type="submit" primary>{{ $t('m1') }}</a-btn>
    </form>
  </div>
</template>

<script>
import AInput from '@/components/ui/AInput';
import ALink from '@/components/ui/ALink';
import ABtn from '@/components/ui/ABtn';
import { validator } from '@/mixins/validator.js';
import { socialLogin } from '@/mixins/socialLogin.js';
import GoogleLogin from 'vue-google-login';

export default {
  components: {
    ALink,
    AInput,
    ABtn,
    GoogleLogin,
  },
  mixins: [validator, socialLogin],
  data() {
    return {
      showPassword: false,
      form: {
        password: {
          value: '',
          error: '',
          rules: [],
        },
        email: {
          value: '',
          error: '',
          rules: [],
        },
      },
    };
  },
  computed: {
    user() {
      const {
        email: { value: email },
        password: { value: password },
      } = this.form;
      return {
        email,
        password,
      };
    },
    social() {
      return this.$store.getters['visualResources/socialLogin'];
    },
  },
  methods: {
    goToForgetPassword(e) {
      e.preventDefault();
      this.$router.push({ name: 'FORGET_PASSWORD' });
    },
    goToSetPin() {
      this.$store.dispatch('register/setRegistrationStep', 'SET_PIN');
      this.$store.dispatch('register/saveLogin', this.user);
      setTimeout(() => {
        this.$router.push({ name: 'SET_PIN' });
      }, 500);
    },
    checkForm(e) {
      e.preventDefault();
      if (this.validateForm()) {
        this.$store
          .dispatch('register/gowgoLogin', this.user)
          .then(resp => {
            this.$store.dispatch('register/checkCookies');
            let step = resp.userStatus;

            if (step === 'EXTERNAL_REGISTER') {
              this.$router.push('/admin/sign-up/external');
            } else {
              if (step === 'NONE') step = 'CREATE_USER';
              if (!this.routes.some(r => r === step)) {
                if (this.authorizedRoutes.some(r => r === step)) {
                  if (resp.hasPin) {
                    this.handleRedirect(resp.defaultContext);
                  } else {
                    this.goToSetPin();
                  }
                } else {
                  let error = this.unauthorizedRoutes.find(
                    r => r.name === step,
                  );
                  if (error) {
                    this.$toast.error(error.errorMessage);
                  } else {
                    this.$toast.error(this.defaultErrorMessage);
                  }
                }
              } else {
                this.$store.dispatch('register/setRegistrationStep', step);
                setTimeout(() => this.$router.push({ name: step }), 500);
              }
            }
          })
          .catch(() => {
            this.loginErrorHandle();
          });
      }
    },
    loginErrorHandle() {
      this.$toast.error(this.$t('toast.loginWrongCredentials'));
    },
  },
  mounted() {
    this.form.email.rules = [this.rules.required, this.rules.email];
    this.form.password.rules = [this.rules.required];
  },
};
</script>
